import BaseAPI from "../api";

const path: string = "/online_course";


export class OnlineCourseApi extends BaseAPI {
    static list(query: any): Promise<any> {
        return this.api.get(`${path}`, {
            params: { ...query },
        });
    }
    static post(body: any): Promise<any> {
        return this.api.post(`${path}`,
            body,
        );
    }
    static patch(body: any, id: any): Promise<any> {
        return this.api.patch(`${path}/${id}/basic_info`,
            body,
        );
    }
    static fileCover(body: any): Promise<any> {
        return this.api.post(`${path}_file_cover`,
            body,
            {
                headers: { "Content-Type": "multipart/form-data" },
            }
        );
    }
    static fileTopics(body: any): Promise<any> {
        return this.api.post(`${path}_file_study_topics`,
            body,
            {
                headers: { "Content-Type": "multipart/form-data" },
            }
        );
    }
    static fileDocument(body: any): Promise<any> {
        return this.api.post(`${path}_file_document`,
            body,
            {
                headers: { "Content-Type": "multipart/form-data" },
            }
        );
    }
    static listLesson(id: any): Promise<any> {
        return this.api.get(`${path}/${id}/lesson`);
    }
    static postLesson(body: any, id: any): Promise<any> {
        return this.api.post(`${path}/${id}/lesson`,
            body,
        );
    }
    static patchLesson(body: any, id: any, id_lesson: any): Promise<any> {
        return this.api.patch(`${path}/${id}/lesson/${id_lesson}`,
            body,
        );
    }

    static listLessonTopic(id: any, id_lesson: any): Promise<any> {
        return this.api.get(`${path}/${id}/lesson/${id_lesson}/study_topic`);
    }
    static postLessonTopic(body: any, id: any, id_lesson: any): Promise<any> {
        return this.api.post(`${path}/${id}/lesson/${id_lesson}/study_topic`,
            body,
        );
    }
    static patchLessonTopic(body: any, id: any, id_lesson: any, id_topic: any): Promise<any> {
        return this.api.patch(`${path}/${id}/lesson/${id_lesson}/study_topic/${id_topic}`,
            body,
        );
    }
    static getLessonTopic(id: any, id_lesson: any, id_topic: any): Promise<any> {
        return this.api.get(`${path}/${id}/lesson/${id_lesson}/study_topic/${id_topic}`);
    }
    static findById(id: any): Promise<any> {
        return this.api.get(`${path}/${id}/basic_info`);
    }
    static getconfigForm(query: any, id: any): Promise<any> {
        return this.api.get(`${path}/${id}/config_form`, {
            params: { ...query },
        });
    }
    static getconfigFormById(id: any, id_config_form: any): Promise<any> {
        return this.api.get(`${path}/${id}/config_form/${id_config_form}`);
    }
    static postConfigForm(body: any, id: any): Promise<any> {
        return this.api.post(`${path}/${id}/config_form`, body,);
    }
    static patchConfigForm(body: any, id: any, id_config_form: any): Promise<any> {
        return this.api.patch(`${path}/${id}/config_form/${id_config_form}`, body,);
    }
    static listTerminology(query: any, id: any): Promise<any> {
        return this.api.get(`${path}/${id}/terminology`, {
            params: { ...query },
        });
    }
    static postTerminology(body: any, id: any): Promise<any> {
        return this.api.post(`${path}/${id}/terminology`, body,);
    }
    static patchTerminology(body: any, id: any, id_terminology: any): Promise<any> {
        return this.api.patch(`${path}/${id}/terminology/${id_terminology}`, body,);
    }
    static listFile(query: any, id: any): Promise<any> {
        return this.api.get(`${path}/${id}/file`, {
            params: { ...query },
        });
    }
    static postFile(body: any, id: any): Promise<any> {
        return this.api.post(`${path}/${id}/file`, body,);
    }
    static patchFile(body: any, id: any, id_file: any): Promise<any> {
        return this.api.patch(`${path}/${id}/file/${id_file}`, body,);
    }
    static getFileById(id: any, id_file: any): Promise<any> {
        return this.api.get(`${path}/${id}/file/${id_file}`);
    }
    static listDiploma(query: any): Promise<any> {
        return this.api.get(`${path}_diploma`, {
            params: { ...query },
        });
    }

    static listTag(query: any): Promise<any> {
        return this.api.get(`${path}_tag`, {
            params: { ...query },
        });
    }
    static listType(query: any): Promise<any> {
        return this.api.get(`${path}_type`, {
            params: { ...query },
        });
    }
    // static getTopics(query: any): Promise<any> {
    //     return this.api.get(`${path}_type`, {
    //         params: { ...query },
    //     });
    // }
    static getForm(query: any): Promise<any> {
        return this.api.get(`${path}_form`, {
            params: { ...query },
        });
    }
    static getFormById(id: any): Promise<any> {
        return this.api.get(`${path}_form/${id}`);
    }
    static getDiploma(id: any): Promise<any> {
        return this.api.get(`${path}_diploma/${id}`);
    }
    static postDiploma(body: any): Promise<any> {
        return this.api.post(`${path}_diploma`,
            body,
            {
                headers: { "Content-Type": "multipart/form-data" },
            }
        );
    }
    static patchDiploma(body: any, id: any): Promise<any> {
        return this.api.patch(`${path}_diploma/${id}`,
            body,
            {
                headers: { "Content-Type": "multipart/form-data" },
            }
        );
    }
    static delete(id: any): Promise<any> {
        return this.api.delete(`${path}/${id}`);
    }
    static deleteDiploma(id: any): Promise<any> {
        return this.api.delete(`${path}_diploma/${id}`);
    }
    static deleteConfigForm(id: any, id_config_form: any): Promise<any> {
        return this.api.delete(`${path}/${id}/config_form/${id_config_form}`);
    }
    static deleteFile(id: any, id_file: any): Promise<any> {
        return this.api.delete(`${path}/${id}/file/${id_file}`);
    }
    static deleteLesson(id: any, id_lesson: any): Promise<any> {
        return this.api.delete(`${path}/${id}/lesson/${id_lesson}`);
    }
    static deleteTopic(id: any, id_lesson: any, id_topic: any): Promise<any> {
        return this.api.delete(`${path}/${id}/lesson/${id_lesson}/study_topic/${id_topic}`);
    }
    static deleteTerminology(id: any, id_terminology: any): Promise<any> {
        return this.api.delete(`${path}/${id}/terminology/${id_terminology}`);
    }

}